// extracted by mini-css-extract-plugin
export var container = "_4s-0";
export var disabled = "_4s-4";
export var fullWidth = "_4s-3";
export var lined = "_4s-1";
export var selected = "_4s-5";
export var tab = "_4s-2";